import { useCallback, useEffect } from 'react';

import log from 'loglevel';

import { useFetchCacheStore } from '../../store';
import { useFetchInstagramConversations } from '../UserCommunications/fetch/useFetchInstagramConversations';

export const useInstagramDataFetch = () => {
  const { markInstagramConversationsAsLoaded, isInstagramConversationsLoaded } =
    useFetchCacheStore();
  const { handleFetchInstagramConversations } =
    useFetchInstagramConversations();

  const onInstagramDataFetch = useCallback(async () => {
    if (isInstagramConversationsLoaded()) {
      log.info('Instagram conversations already loaded, skipping fetch');
      return;
    }

    try {
      await handleFetchInstagramConversations();
      markInstagramConversationsAsLoaded();
    } catch (error) {
      log.error('Error fetching Instagram conversations:', error);
    }
  }, [isInstagramConversationsLoaded, markInstagramConversationsAsLoaded]);

  useEffect(() => {
    onInstagramDataFetch();
  }, []);
};
